/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {ServerObjectInstance} from "../models/server-object-instance";
import {ServerObjectService} from "../services/server-object.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {PAGING_ITEMS_PER_PAGE} from "../app-constants";
import { PagedResults } from "app/models/paged-results";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class ServerObjectInstancesPagingResolver implements Resolve<PagedResults<ServerObjectInstance>> {

  constructor(
    private mServerObjectService: ServerObjectService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<ServerObjectInstance>> {
    try {
      return await this.mServerObjectService.getAllServerObjectInstancesForPaging(0, PAGING_ITEMS_PER_PAGE, 'ASC', "");
    } catch (error) {
      console.error("Problem resolving Server Object Instances... Error: " + error, error);
    }
  }

}
